import { FadeIn } from "@/components/common/FadeIn";

const cases = [
  {
    title: "EXPORTACIONES",
    companies: [
      "Agricom", "Río Blanco", "Río King", "Subsole", "Copefrut",
      "Mares Australes", "Salmones Magallanes", "ZC Logistics",
      "Gonzagri", "Agrofruta", "CyD Internacional", "Vission Fresh",
      "Frutango", "Aztecavo – México", "Incavo – Perú",
      "Westfalia Fruits – Colombia",
    ],
    image:
      "https://images.unsplash.com/photo-1579900213737-97f95c032949?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "ENERGÍA",
    companies: ["Chilquinta", "Energas", "Litoral"],
    image:
      "https://images.unsplash.com/photo-1758429295457-ba071dfb22eb?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "SERVICIOS Y OTROS",
    companies: [
      "Generaxxion Inmobiliaria", "Vantrust Gestora Inmobiliaria",
      "Ultramar", "AFP Habitat", "Ministerio de Vivienda y Urbanismo",
      "Banedwards Factoring Finersa", "Feria Agrícola de Talca",
      "Laboratorios Ballerina", "HNS Factoring",
      "Minera Tauro", "Minera del Norte",
    ],
    image:
      "https://images.unsplash.com/photo-1758518727820-28491c194bee?auto=format&fit=crop&w=1400&q=80",
  },
];

export const CaseStudies = () => {
  return (
    <section id="casos" className="py-20 md:py-28" data-testid="case-studies-section">
      <div className="section-container">
        <FadeIn>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="case-studies-kicker-text">
            Casos de éxito
          </p>
          <h2 className="mt-3 text-base md:text-lg text-slate-600" data-testid="case-studies-subheading-text">
            Historias donde estrategia y ejecución se transformaron en impacto medible.
          </h2>
        </FadeIn>

        <div
          className="mt-10 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4"
          data-testid="case-studies-horizontal-strip"
        >
          {cases.map((caseItem, index) => (
            <FadeIn key={caseItem.title} delay={0.08 * (index + 1)} className="min-w-[320px] flex-1 snap-start md:min-w-[420px]">
              <article className="relative h-[420px] overflow-hidden border border-slate-200" data-testid={`case-study-card-${index + 1}`}>
                <img
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="h-full w-full object-cover object-center"
                  data-testid={`case-study-image-${index + 1}`}
                />
                <div
                  className="absolute inset-0 flex flex-col bg-gradient-to-b from-slate-900/15 via-slate-900/30 to-slate-900/90 p-7"
                  data-testid={`case-study-overlay-${index + 1}`}
                >
                  <h3 className="corporate-title-balance text-2xl text-white" data-testid={`case-study-title-${index + 1}`}>
                    {caseItem.title}
                  </h3>
                  <ul className="mt-auto space-y-0.5" data-testid={`case-study-companies-${index + 1}`}>
                    {caseItem.companies.map((company) => (
                      <li key={company} className="text-sm text-slate-200">
                        {company}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};
